import { useContext } from 'react';
import { MainLayoutContext, IMainLayoutContextContext } from './MainLayoutContext';

export const useMainLayout = () => useContext<IMainLayoutContextContext>(MainLayoutContext);
